export const constSystemFeature = {
    LOAD_SYSTEM_FEATURE: 'LOAD_SYSTEM_FEATURE',
};
